var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLink(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.16016 8.2913C8.18934 9.7428 10.3569 9.48808 11.4186 8.2913L13.5301 6.16797C14.7238 4.86416 14.7661 3.18057 13.5301 1.92131C12.3245 0.692896 10.4891 0.692896 9.28349 1.92131L7.16016 4.04464M9.28116 7.30276C8.25197 5.85126 6.09617 6.0319 5.0345 7.22869L2.91117 9.32534C1.71749 10.6291 1.67525 12.3394 2.91117 13.5986C4.11682 14.8271 5.95218 14.8271 7.15783 13.5986L9.28116 11.4753",
    stroke: "#777E90",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLink);
export default __webpack_public_path__ + "static/media/link.1ee9744bf593559fce47e200ab962aad.svg";
export { ForwardRef as ReactComponent };